import {useMemo} from 'react';

import {useCharacterItemsQuery} from '../../../../generated/types';
import type {EquipmentEntry} from '../model/character-state';
import {BASE_ITEM_CHOICE, ItemRecord} from '../model/equipment';

export function useEquipmentItems(equipment: EquipmentEntry[]): Map<string, ItemRecord> {
	const ids = useMemo(
		() =>
			[
				...new Set(equipment.flatMap((entry) => [entry.itemId, ...(entry.choices?.[BASE_ITEM_CHOICE] || [])])),
			].sort(),
		[equipment],
	);
	const {data, previousData} = useCharacterItemsQuery({variables: {ids}, skip: !ids.length, ssr: false});
	const items = (data || previousData)?.itemsByIds;

	return useMemo(() => new Map((items || []).map((item) => [item.id, item])), [items]);
}
